import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button as AntdButton, Input, Popover, Tooltip} from "antd";
import styled from "styled-components";
import {MdSearch} from 'react-icons/md';
import {DownloadOutlined, UploadOutlined} from "@ant-design/icons";
import debounce from "lodash/debounce";

const SearchSection = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 10px;
  margin-bottom: 7px;
`

const H3 = styled.p`
  font-size: 16px;
  font-weight: bold;
  margin: 0;
  padding: 0;
`
const Button = styled.button`
  background-color: transparent;
  margin-top: 2px;
  padding: 5px 0 0;
  outline: none;
  border: 1px solid #244E9A;
  border-radius: 4px;

  &:hover {
    transition: all 0.1s ease-in-out;
    cursor: pointer;
    border: 1px solid #244E9A;
  }

  display: ${props => props.isVisible ? 'block' : 'none'};

`

const SearchInput = styled(Input)`
  border: none;
  border-bottom: 1px solid #244E9A;

`

const Span = styled.span`
  background-color: #e2e200;
  color: black;
  padding: 2px 10px;
  font-weight: bold;
  border-radius: 5px;
  margin-right: 15px;
`

const rightStyle = {
    display: 'flex',
    justifyContent: "flex-end",
    gap: '20px',
};
const contentList = [
    'First Download the Csv From the download Button',
    "Open the file from Excel-sheet",
    "Edit the Data without adding any new header",
    "Import from upload button of particular Organization's Tabs",
];

const content = (
    <div>
        {contentList.map((item, index) => {
            return <p key={index}><span>{index + 1}.</span> {item}</p>
        })}
        <p style={{color: "red", fontWeight: 'bold'}}> NOTE: DO NOT ADD/DELETE/EDIT THE HEADER, AND DO NOT
            ADD ID WHILE ADDING NEW DATA (ID WILL BE AUTO GENERATED FOR YOU)</p>
    </div>
)

class SearchBox extends Component {
    render() {
        const {
            title,
            onSearchClick,
            onDownloadClick,
            isUploadVisible,
            onUploadClick,
            isVisible,
            length,
            showTableLength
        } = this.props;
        return (
            <SearchSection isSearchable={isVisible}>
                <H3>{title} {showTableLength && <Span>{length}</Span>}</H3>
                <div style={rightStyle}>
                    {isUploadVisible &&
                        <Popover content={content} title={"How To Upload CSV ?"}>
                            <AntdButton onClick={onUploadClick} isVisible={isUploadVisible}><UploadOutlined size={20}/></AntdButton>
                        </Popover>
                    }
                    {
                        isVisible && (
                            <Tooltip arrowPointAtCenter title={'Download Data'}>
                                <AntdButton onClick={onDownloadClick} icon={<DownloadOutlined
                                    color={'#244E9A'} size={20}
                                />}/>
                            </Tooltip>
                        )
                    }
                    <SearchInput allowClear placeholder={"Search here."} onChange={(event) => {
                        const debounceSearch = debounce((event) => onSearchClick(event), 450)
                        debounceSearch(event.target.value || "");
                    }}
                                 prefix={<MdSearch color={'#244E9A'}
                                                   size={21}/>}/>
                </div>
            </SearchSection>

        );
    }
}

SearchBox.propsTypes = {
    title: PropTypes.string,
    onSearchClick: PropTypes.func,
    showTableLength: PropTypes.bool,
    length: PropTypes.number
}

export default (SearchBox);
